<p-button
    id="{{ uid }}"
    [label]="label"
    styleClass="p-button-link"
    (onClick)="onClick($event)"
></p-button>